export enum gridconfig {
  gridHeight = 410,
  gridHeightWithoutHeader = 550,
  gridHeightForScheduleTabs = 280,
  gridHeightForPlanDetailTab = 240,
  gridHeightForPlanVor = 275,
  gridHeightForPlanIntercart = 175,
  gridHeightForRequestTabs = 275,
  gridHeightForInspectionDetailTab = 240,
  gridHeightForTripSummaryDetailTab = 290,
  gridHeightForTripSummaryDetailUnloadingTab = 310,
  gridHeightForScoreCardTab = 350,
  gridHeightForException = 370,
  gridHeightForJourneyPlan = 300,
  gridHeightForJourneyPlanCreation = 265,
  gridHeightForAddToExisting = 400,
  gridHeightForPsngrQuickRes = 430,
  gridHeightForShuttleMapping = 190,
  gridHeightForShuttleSummary = 400,
  gridHeightForAllocate = 330,
  gridHeightForReqRouting = 500,
  gridHeightForApproveMaster = 500,
  gridHeightForShuttleManagement = 370,
  gridHeightForJourneyBoard = 480,
  gridHeightForLMSScore = 180,
  gridHeightForIVMSScore = 170,
  gridHeightForDriverLPDetail = 490,
}

export enum masterGridConfig {
  gridHeightForMasterList = 410,
  gridHeightForException = 450,
  gridHeightVehicle = 410,

  gridHeightForCalenderTabs = 260,
  gridHeightforChecklistDetails = 360,
  gridHeightforConstrainttDetails = 360,
  gridHeightforEmployeeDetails = 270,
  gridHeightForFeedback = 420

}
export enum validationMsgConfig {
  nameValidationMessage = "Allowed alphabets and space only.",
  alphanumericNameValidationMessage = "Allowed alphanumeric,space,underscore(_) and hyphen(-) only.",
  alphanumericCodeValidationMessage = "Allowed alphanumeric and underscore(_) only.",
  numericValidationMessage = "Allowed numeric values only.",
  floatValidationMessage = "Allowed numeric and float values only.",
  alphanumericValidationMessage = "Allowed alphanumeric values only",
  phoneValidationMessage = "Allowed numeric, plus(+), space, slash(/) and hyphen(-) symbols only.",
  latlngValidationMessage = "Allowed numeric,dot(.) and minus(-) symbols only.",
  numRangeValidationMessage = "Minimum booking count should be above 8.",
  grpBookingValidationMessage = "Allowed between 0 to 66 numeric values only."
}
export enum validationConfig {
  nameValidation = "^[a-zA-Z ]*$",
  alphanumericNameValidation = "^[0-9a-zA-Z-_ ]*$",
  alphanumericCodeValidation = "^[0-9a-zA-Z_]*$",
  numberValidation = "^[0-9]*$",
  alphanumericValidation = "^[0-9a-zA-Z]*$",
  floatValidation = "^[0-9.]*$",
  phoneValidation = "^(?=.*[0-9])[- \/+()0-9]+$",
  zipCodeValidation = "^[0-9]*$",
  latlngValidation = "^[0-9.-]*$",
  numRangeValidation = "^([8-9]|[12]\d|6[0-6])$"
}
export enum StateTypes{
  DRIVE = 1,
  STOP = 2,
  IDLING = 4,
  NONREPORTING = 12,
  ROAD_IDLING = 56
}